import React from 'react'
import ClassNames from 'classnames'

import {
  ModalStyle,
  ModalContentStyle,
  ModalHeaderStyle,
  ModalBodyStyle,
  ModalFooterStyle,
  ModalBackgroundStyle,
  ModalCloseButtonStyle,
  ModalDialogStyle,
} from './style'
import { Image } from 'components'
import { ICONS } from 'themes'

// function renderSize(size) {
//   switch (size) {
//     case 'sm':
//       return '575px'
//     case 'lg':
//       return '768px'
//     case 'xl':
//       return '1300px'
//     default:
//       return null
//   }
// }

const ModalHeaderContainer = props => {
  const {
    className, //
    children,
  } = props

  return (
    <ModalHeaderStyle className={ClassNames('modal-custom-header', className)}>
      {children}
    </ModalHeaderStyle>
  )
}

const ModalBodyContainer = React.forwardRef((props, ref) => {
  const {
    className, //
    children,
    style,
  } = props
  return (
    <ModalBodyStyle
      className={ClassNames('modal-custom-body', className)}
      ref={ref}
      style={style}
    >
      {children}
    </ModalBodyStyle>
  )
})

const ModalFooterContainer = props => {
  const {
    className, //
    children,
  } = props
  return (
    <ModalFooterStyle className={ClassNames('modal-custom-footer', className)}>
      {children}
    </ModalFooterStyle>
  )
}

const ModalBackgroundContainer = props => {
  const { onClick } = props
  return (
    <ModalBackgroundStyle
      className="modal-custom-background"
      onClick={onClick}
    />
  )
}

const ModalDialogContainer = props => {
  const { children } = props
  return (
    <ModalDialogStyle className="modal-custom-dialog">
      {children}
    </ModalDialogStyle>
  )
}

const ModalContentContainer = props => {
  const { className, children, onClick } = props
  return (
    <React.Fragment>
      <ModalContentStyle
        className={ClassNames('modal-custom-content', className)}
        onClick={onClick}
      >
        {children}
      </ModalContentStyle>
    </React.Fragment>
  )
}

ModalContentContainer.defaultProps = {
  className: '',
}

const ModalCloseButtonContainer = props => {
  const {
    className, //
    children,
    closeSrc,
    onClick,
  } = props
  return (
    <React.Fragment>
      <ModalCloseButtonStyle
        className={ClassNames('modal-custom-close-button', className)}
        onClick={onClick}
      >
        {children ? children : <Image src={ICONS[closeSrc]} />}
      </ModalCloseButtonStyle>
    </React.Fragment>
  )
}

export class Modal extends React.Component {
  static Header = ModalHeaderContainer
  static Body = ModalBodyContainer
  static Footer = ModalFooterContainer
  static CloseButton = ModalCloseButtonContainer

  render() {
    const {
      id,
      className,
      children,
      onClickClose,
      isOpen,
      hideCloseButton,
      onClickBackground,
      demoZoomReverse,
      demoZoom,
      classNameContainer,
      modalWidth,
    } = this.props
    return (
      <React.Fragment>
        <ModalStyle
          id={id}
          className={ClassNames(
            'modal-custom',
            isOpen ? 'is-open' : null,
            className
          )}
          demoZoomReverse={demoZoomReverse}
          demoZoom={demoZoom}
          setWidth={modalWidth}
        >
          <ModalDialogContainer>
            <ModalBackgroundContainer onClick={onClickBackground} />

            <ModalContentContainer className={classNameContainer}>
              {!hideCloseButton && (
                <ModalCloseButtonContainer onClick={onClickClose} />
              )}
              {children}
            </ModalContentContainer>
          </ModalDialogContainer>
        </ModalStyle>
      </React.Fragment>
    )
  }
}

Modal.defaultProps = {
  isModalOpen: false,
  hideCloseButton: true,
  popupUI: true,
}

ModalHeaderContainer.defaultProps = {}

ModalBodyContainer.defaultProps = {}

ModalFooterContainer.defaultProps = {}

ModalBackgroundContainer.defaultProps = {}

ModalCloseButtonContainer.defaultProps = {
  closeSrc: 'icon-close.svg',
}
